import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Eye16Filled,
  Certificate16Regular,
  ListBar16Filled,
  TableSimple16Regular,
  MoreHorizontal16Regular,
  Attach16Regular,
  ArrowReply16Filled,
  MoreCircle16Regular,
  MoreVertical16Filled,
} from "@fluentui/react-icons";
import {
  Label,
  Menu,
  MenuButton,
  MenuItem,
  MenuItemLink,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Tooltip,
  Image,
  Text,
  Link,
  tokens,
  makeStyles,
  Card,
  CardFooter,
  CardHeader,
  CardPreview,
  Button,
  typographyStyles,
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogContent,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  component: {
    paddingRight: tokens.spacingHorizontalM,
  },
  tools: {
    marginBottom: tokens.spacingVerticalM,
    textAlign: "right",
  },
  cards: {
    marginBottom: tokens.spacingVerticalM,
  },
  card: {
    marginBottom: tokens.spacingVerticalM,
  },
  cardPreview: {
    paddingLeft: tokens.spacingVerticalM,
    paddingRight: tokens.spacingVerticalM,
  },
  toolsButton: {
    marginLeft: tokens.spacingHorizontalSNudge,
  },
  label: {
    display: "block",
    color: tokens.colorBrandStroke1,
    fontWeight: tokens.fontWeightBold,
  },
  text: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    marginRight: tokens.spacingHorizontalSNudge,
  },
  textBlock: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
    display: "block",
  },
  textStrong: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
  textLink: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightRegular,
  },
  textLinkStrong: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightBold,
  },
  inline: {
    display: "inlineBlock",
  },
});

const Email = (props) => {
  const { data, domain, loading } = props;
  const styles = useStyles();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState({});

  const viewEmailDialog = (email) => {
    setDialogData(email);
    setDialogOpen(true);
  };

  return (
    <section className={styles.component}>
      {loading == false ? (
        data && data.length ? (
          <div className={styles.cards}>
            {data.map((email) => {
              return (
                <Card className={styles.card} key={email.id}>
                  <CardHeader
                    header={
                      <Link onClick={() => props.sendEmail(email.from.address)} className={styles.textLinkStrong}>
                        {email.from.name}
                      </Link>
                    }
                    action={
                      <div>
                        <Text className={styles.text}>{new Date(email.receivedDateTime.date).toLocaleString()}</Text>
                        <Menu>
                          <MenuTrigger disableButtonEnhancement>
                            <MenuButton icon={<MoreVertical16Filled />} size="small" appearance="transparent" />
                          </MenuTrigger>
                          <MenuPopover>
                            <MenuList>
                              <MenuItemLink icon={<Eye16Filled />} onClick={() => viewEmailDialog(email)}>
                                View
                              </MenuItemLink>
                              <MenuItemLink
                                icon={<ArrowReply16Filled />}
                                onClick={() => props.sendEmail(email.from.address)}
                              >
                                Reply
                              </MenuItemLink>
                            </MenuList>
                          </MenuPopover>
                        </Menu>
                      </div>
                    }
                  />
                  <CardPreview className={styles.cardPreview}>
                    <Text className={email.isRead ? styles.text : styles.textStrong}>
                      {email.hasAttachments && <Attach16Regular />}
                      {email.subject}
                    </Text>
                  </CardPreview>
                  <CardFooter></CardFooter>
                </Card>
              );
            })}
          </div>
        ) : (
          <Text className={styles.text}>No email found</Text>
        )
      ) : (
        <Text>Loading...</Text>
      )}
      <Dialog
        open={dialogOpen}
        onOpenChange={(event, data) => {
          setDialogOpen(data.open);
        }}
      >
        <DialogSurface>
          <DialogBody>
            <DialogTitle>{dialogData?.from?.name}</DialogTitle>
            <DialogContent>
              <Text className={styles.textBlock}>{dialogData?.from?.address}</Text>
              <Text className={styles.textBlock}>{dialogData?.subject}</Text>
              <div className={styles.textBlock} dangerouslySetInnerHTML={{ __html: dialogData?.body }} />
            </DialogContent>
            <DialogActions>
              <DialogTrigger disableButtonEnhancement>
                <Button appearance="secondary">Close</Button>
              </DialogTrigger>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </section>
  );
};

Email.propTypes = {
  query: PropTypes.object,
};

export default Email;
